import React, { FC } from 'react';

import { LoaderLabel, Overlay, PageLoader, Spinner } from './styled';

interface LoaderProps {
  size?: number;
  overlay?: boolean;
  /** Fills the page content area without covering the app shell. */
  page?: boolean;
  label?: string;
}

export const Loader: FC<LoaderProps> = ({
  size = 40,
  overlay = false,
  page = false,
  label,
}) => {
  const spinner = (
    <>
      <Spinner $size={size} role="status" aria-label={label || 'Loading'} />
      {label ? <LoaderLabel>{label}</LoaderLabel> : null}
    </>
  );

  if (overlay) {
    return <Overlay>{spinner}</Overlay>;
  }

  if (page) {
    return <PageLoader>{spinner}</PageLoader>;
  }

  return spinner;
};
